import { markdown, ReactSpecimen } from "catalog";
import { TagList, HorizontalTagList } from "./TagList";
const sampleTagItems = [
    { label: "Lorem ipsum", "@id": "foo", "@type": "Dimension" },
    {
        label: "dolor sit amet consectetur",
        "@id": "foo2",
        "@type": "Dimension"
    },
    { label: "adipisicing", "@id": "foo3", "@type": "Topic" },
    { label: "Eum ipsam cupiditate", "@id": "foo4", "@type": "Dimension" },
    { label: "quibusdam commodi", "@id": "foo5", "@type": "Topic" },
    { label: "ducimus esse sint", "@id": "foo6", "@type": "Dimension" },
    { label: "error accusantium", "@id": "foo8", "@type": "Time" },
    { label: "labore reprehenderit", "@id": "foo7", "@type": "Location" }
];
export default () => markdown `

## Tag Suggestions

${(<ReactSpecimen>
    <TagList tags={sampleTagItems} getTagProps={(t, index) => (index === 3 ? { appearance: "dark" } : {})}/>
  </ReactSpecimen>)}

${(<ReactSpecimen>
    <TagList showTitles={false} tags={sampleTagItems} getTagProps={(t, index) => (index === 3 ? { appearance: "dark" } : {})}/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark>
    <HorizontalTagList tags={sampleTagItems} getTagProps={(t, index) => index === 3 ? { appearance: "inverted" } : {}}/>
  </ReactSpecimen>)}


`;



// WEBPACK FOOTER //
// ./src/components/TagList.docs.tsx